import { BehaviorSubject } from 'rxjs';
import { /* config, */handleResponse } from '../_helpers';


//const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
const currentUserSubject = new BehaviorSubject(JSON.parse(sessionStorage.getItem('currentUser')));

 export  const authenticationService = {
    login,
    logout,
    changePassword,
    allUsers,
    //userLangMe,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

 async function login(email, password) {
  
    var raw = JSON.stringify({ email, password });

    
    var requestOptions = { 
        method: 'POST',
        //mode: 'no-cors',
        headers: { "Content-Type": "application/json"  },
        body: raw,
        redirect: 'follow'
    };
    debugger;
    const respuesta = await fetch( window.config.HostUrlAuth+"vusuario/login", requestOptions)
        .then(handleResponse)
        .then(user => {
            //store user details and jwt token in local storage to keep user logged in between page refreshes
            //localStorage.setItem('currentUser', JSON.stringify(user));
            debugger;
            var l_config = {HostUrl:window.config.HostUrl,
                            HostUrlAuth:window.config.HostUrlAuth,
                            HostEndUrl:window.config.HostEndUrl}
            sessionStorage.setItem('config', JSON.stringify(l_config));
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);


            return user;
        })
        .catch(err => Promise.reject('Error de autenticación! Por favor validar email o password.') );
 /*                    .then(response => {
                        localStorage.setItem('x-access-token', response.data.token);
                        localStorage.setItem('x-access-token-expiration', Date.now() + 2 * 60 * 60 * 1000);
                        console.log(response)
                        //return response
                        })
                    .catch(err => Promise.reject('Authentication Failed!') ); */
    //const token = await respuesta.json()


    return respuesta;
}

async function changePassword(token,email,password) {
    var fetchHeaders={};

    if (token) {
        fetchHeaders= { "Content-Type": "application/json", "api-token": `${token}` };
    } 
    var raw = JSON.stringify({ email, password });

    var requestOptions = { 
        method: 'PUT',
        //mode: 'no-cors',
        headers: fetchHeaders,
        body: raw,
        redirect: 'follow'
    };
    const resp = await fetch( window.config.HostUrlAuth+"usuario/me", requestOptions)
    .then(handleResponse)
    .then(info => {

       return info;
    })
    .catch(err => console.log('Error de cambio de contraseña.') )
    ;

    return resp;
}

async function allUsers(token) {
    var fetchHeaders={};

    if (token) {
        fetchHeaders= { "Content-Type": "application/json", "api-token": `${token}` };
    } 
    var requestOptions = { 
        method: 'GET',
        //mode: 'no-cors',
        headers: fetchHeaders,
        redirect: 'follow'
    };
    const resp = await fetch( window.config.HostUrlAuth+"usuario/me", requestOptions)
    .then(handleResponse)
    .then(info => {

       return info;
    })
    .catch(err => console.log('Error de cambio de contraseña.') )
    ;

    return resp;
}

function logout() {
    // remove user from local storage to log user out
    //localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}
 